export default __webpack_public_path__ + "static/media/Code-of-Conduct-2025.1a455d9c.pdf";